import React from 'react';
import PropTypes from 'prop-types';
import { TranslationProvider } from '@resy/ui-kitchen';

import './NoResults.scss';

const NoResults = ({ onClear, query }) => {
  if (query && query.type === 'query' && query.value) {
    return (
      <div className="NoResults">
        <div
          aria-live="assertive"
          role="alert"
          aria-atomic="true"
        >
          <TranslationProvider translationKey="search_no_results_query_header" translationValues={{ query: query.value }}>
            <h1>{`No Results for &ldquo;${query.value}&ldquo;.`}</h1>
          </TranslationProvider>
          <TranslationProvider translationKey="search_no_results_query_body">
            <div
              className="color--text-secondary"
            >
              Try another search, adjust party size and date, or zoom out.
            </div>
          </TranslationProvider>
        </div>
        <TranslationProvider translationKey="clear_search">
          <button className="NoResults__clear" type="button" onClick={onClear}>Clear Search</button>
        </TranslationProvider>
      </div>
    );
  }

  return (
    <div className="NoResults" data-test-id="no_results">
      <div
        aria-live="assertive"
        role="alert"
        aria-atomic="true"
      >
        <TranslationProvider translationKey="search_no_results_default">
          <h1>No tables available.</h1>
        </TranslationProvider>
        <TranslationProvider translationKey="search_no_results_query_body">
          <div>
            Try another search, adjust party size and date, or zoom out.
          </div>
        </TranslationProvider>
      </div>
      <TranslationProvider translationKey="">
        <button className="NoResults__clear" type="button" onClick={onClear}>Clear Search</button>
      </TranslationProvider>
    </div>
  );
};

NoResults.propTypes = {
  onClear: PropTypes.func.isRequired,
  query: PropTypes.shape({
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

NoResults.defaultProps = {
  query: null,
};

NoResults.displayName = 'NoResults';

export default NoResults;
